// Display formatting for coordinate-plane values and the canonical coordinate id.
// Purely presentational — the canonical id (see coordId.js) is never altered; we
// only derive a short, human-glanceable token from it for the specimen placard.

// A complex-plane value, formatted for a museum-style placard: enough precision
// to be meaningful at deep zooms, without spilling raw 17-digit float noise
// (e.g. -0.8695703125 -> "-0.86957031"). Very small magnitudes fall back to
// significant-figure notation so a deep zoom doesn't collapse to "0.00000000".
export const formatCoord = (value) => {
    if (!Number.isFinite(value)) return '—';
    const magnitude = Math.abs(value);
    if (magnitude !== 0 && magnitude < 1e-6) {
        return value.toExponential(4);
    }
    // Fixed 8dp, then trim trailing zeros (but keep at least one decimal place).
    let s = value.toFixed(8).replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '.0');
    return s;
};

// Deterministic short token derived from the canonical id, for at-a-glance
// identification on the placard/filmstrip. FNV-1a -> 6 hex chars. This is a
// display convenience, NOT the identity: uniqueness is still enforced on the
// full canonical id from coordId.js.
export const shortId = (id) => {
    let hash = 0x811c9dc5;
    for (let i = 0; i < id.length; i++) {
        hash ^= id.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193);
    }
    return (hash >>> 0).toString(16).padStart(8, '0').slice(0, 6);
};
